<a class="product" [routerLink]="['/produtos', produto.slug]">
    <div class="product-image">
        <img [src]="global.imageUrl+produto.imagem" [alt]="produto.descricao">
    </div>
    <div class="product-title">
        {{produto.nome}}
    </div>
</a>